import { Box, Breadcrumbs } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { generatePath, Link, useHistory } from 'react-router-dom';
import { Home } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import Bluebird from 'bluebird';
import {
  StyledRescuerBreadcrumb,
  StyledRescuerTextBreadcrumb,
} from '../../../rescuerDashboard/rescuerDashboardMobile/Components/StyledRescuerBreadcrumb';
import routes from '../../../../routes';
import FoodDonorPickupLocationAddForm from '../../../../components/FoodDonorPickupLocationAddForm';
import { createFoodDonorPickupLocation, fetchFoodDonorPickupLocations } from '../../../../actions/foodDonors';
import snackbarHelper from '../../../../helpers/snackbarHelper';

const FoodDonorMobileLocationAddBreadcrumb = () => {
  const { formatMessage } = useIntl();

  return (
    <Box boxShadow={0}>
      <Breadcrumbs aria-label="breadcrumb">
        <StyledRescuerBreadcrumb
          component={Link}
          to={generatePath(routes.mobileDashboard)}
          label={formatMessage({ id: 'breadcrumbs.home' })}
          icon={<Home style={{ color: '#fff' }} fontSize="small" />}
        />
        <StyledRescuerTextBreadcrumb
          component={Link}
          to={generatePath(routes.mobileDashboardFoodDonorLocations)}
          label={formatMessage({ id: 'breadcrumbs.food-donor-locations' })}
        />
        <StyledRescuerTextBreadcrumb
          component="a"
          href="#"
          label={formatMessage({ id: 'breadcrumbs.food-donor-location-add' })}
        />
      </Breadcrumbs>
    </Box>
  );
};

const FoodDonorMobilePickupLocationAdd = ({ foodDonorId }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onCreateFoodDonorPickupLocation = (data) =>
    Bluebird.try(() => dispatch(createFoodDonorPickupLocation(foodDonorId, data)))
      .then(() => dispatch(fetchFoodDonorPickupLocations(foodDonorId)))
      .then(() => {
        snackbarHelper.success('Pickup Location added successfully!');

        return history.push(generatePath(routes.mobileDashboardFoodDonorLocations));
      });

  if (!foodDonorId) {
    return history.push(generatePath(routes.mobileDashboardFoodDonorLocations));
  }

  return (
    <>
      <FoodDonorMobileLocationAddBreadcrumb />

      <Box py={2} px={1}>
        <FoodDonorPickupLocationAddForm isMobile createFoodDonorPickupLocation={onCreateFoodDonorPickupLocation} />
      </Box>
    </>
  );
};

export default FoodDonorMobilePickupLocationAdd;
